import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminDockerImages = {
  pageTitle: "共享容器镜像",
  pageSubtitle: "只读展示环境中心已启用且共享的容器镜像，用于业务实例化与引用排查。",
  summary: {
    total: "镜像总数：{count}",
    configuredPorts: "已配置端口：{count}",
    defaultPorts: "默认端口：{count}",
    sourceSnapshots: "来源实例快照：{count}",
  },
  guidance: {
    baseImageHint: "当前列表为环境中心共享镜像投影视图，仅用于实例化与引用排查。",
  },
  table: {
    code: commonShortFieldLabels.code,
    name: "镜像标识",
    displayName: "镜像名称",
    id: "ID",
    size: "大小",
    declaredPorts: "声明端口",
    effectivePorts: "生效端口",
    createdAt: commonShortFieldLabels.createdAt,
    description: "描述",
    tags: "标签",
    sourceInstance: "来源实例",
    businessReferences: "业务引用",
    status: commonShortNouns.status,
    actions: "操作",
  },
  references: {
    referenceType: "引用类型",
    resourceType: "资源类型",
    resourceId: "资源 ID",
    label: "展示名称",
    status: commonShortNouns.status,
    updatedAt: commonShortFieldLabels.updatedAt,
    totalReferences: "引用总数：",
  },
  dialogs: {
    pullTitle: "拉取镜像",
    importTitle: "导入镜像包（tar）",
    importHint: "支持导入 `docker save` 导出的镜像包；导入后会自动刷新镜像列表。",
    currentFile: "当前文件：{name}",
    noFileSelected: "尚未选择文件",
    buildDockerfileTitle: "在线构建镜像（Dockerfile）",
    metadataTitle: "镜像端口配置",
    customFieldsTitle: "镜像自定义字段",
    declaredPortsTitle: "镜像声明端口（EXPOSE）",
    selectablePortsTitle: "可选端口",
    defaultPortTitle: "默认端口",
    instantiateTitle: "实例化镜像",
    referenceTitle: "镜像业务引用",
  },
  form: {
    imageName: "镜像标识",
    imageNameRequired: "请输入镜像标识",
    imageNamePlaceholder: "例如：nginx:alpine",
    importSource: "导入来源",
    importSourceUpload: "浏览器上传 tar",
    importSourceAsset: "从资产中心选择 tar",
    assetPlaceholder: "请输入关键词搜索资产 tar 包",
    assetHint: "建议先在资产中心上传 tar，再在这里选择导入，可减少浏览器直传不稳定问题。",
    description: "描述",
    descriptionPlaceholder: "镜像说明",
    tags: "标签（逗号分隔）",
    tagsPlaceholder: "例如：v1.1,practical",
    dockerfileContent: "Dockerfile 内容",
    dockerfileContentRequired: "请输入 Dockerfile 内容",
    dockerfileContentPlaceholder: "例如：\nFROM nginx:alpine\nCOPY ./site /usr/share/nginx/html",
    buildArgsJson: "构建参数 JSON（可选）",
    buildArgsJsonPlaceholder: '例如：{"HTTP_PROXY":"http://proxy:3128"}',
    noCacheBuild: "无缓存构建（--no-cache）",
    buildArgsJsonInvalid: "构建参数 JSON 格式不正确，应为对象格式。",
    noDeclaredPorts: "该镜像未声明端口，请先在镜像中 EXPOSE。",
    selectAllPorts: "全选",
    clearPorts: "清空",
    selectAtLeastOnePort: "请至少选择一个可选端口。",
    selectSelectablePortFirst: "请先在“可选端口”中至少勾选一个端口。",
    currentPortConfig: "当前配置：可选 {count} 个，默认 {port}",
    metadataHint: "题目创建时将基于此配置展示端口下拉；若未配置，将回退镜像声明端口。",
  },
  actions: {
    importTar: "导入 tar 包",
    buildDockerfile: "在线构建",
    startBuild: "开始构建",
    pullImage: "拉取镜像",
    viewReferences: "查看引用",
    instantiate: "实例化",
    configurePorts: "端口配置",
    customFields: "自定义字段",
  },
  statuses: {
    available: "可用",
  },
  confirmDelete: {
    title: "确认删除该镜像？",
  },
  messages: {
    pullSuccess: "镜像拉取完成",
    removeSuccess: "镜像已删除",
    importSuccess: "镜像导入完成",
    importSuccessWithCount: "镜像导入完成，识别到 {count} 个镜像",
    buildSuccess: "镜像构建完成",
    buildSuccessWithImage: "镜像构建完成：{image}",
    metadataUpdated: "镜像端口配置已更新",
    customFieldsSaved: "镜像自定义字段已保存",
  },
  logs: {
    importTitle: "导入日志",
    buildTitle: "构建日志",
  },
} as const;
